/**============================================================
*   [addJobHistoryBlock]
*   description : 職歴入力ブロックを追加・削除
============================================================*/

// option要素の年数を動的に生成
const addYearList = () => {
    const date = new Date();
    const startYear = 1930;
    const endYear = date.getFullYear();
    const term = endYear - startYear;
    let str = '';
    for(var i=0; i <= term; i++) {
      let value = endYear - i;
      str += '<option value="'+value+'">'+value+'</option>\n'
    }
    return str;
}

//テンプレートを定義
  const template =
    '<div class="l-gap--md js-job-history">\n<table class="c-table c-table--form c-table--w246">\n<thead>\n<tr>\n<th colspan="2">\n<div class="d-flex">\n <span class="js-add-block-title">職歴1</span>\n <span class="c-text-md u-ml--auto js-remove-block">\n <button type="button" class="c-link-text c-form-upload__delete">\n <i class="c-icon" aria-hidden="true">\n <svg class="svg-icon_plus_s-dims">\n<use xlink:href="/cms/wp-content/themes/mizuho-bp/assets/img/shared/sprite.symbol.svg#icon_plus_s"></use>\n</svg>\n </i>\n 削除</button>\n </span>\n</div>\n</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<th>期間</th>\n<td>\n<div>\n<ul class="c-list-icon">\n<li>\n <span class="c-list-icon__icon c-text-sm">※</span>\n <span class="c-list-icon__text c-text-sm">現在も就業中の場合は、終了期間はエントリー時点の年月を入力してください。</span>\n</li>\n</ul>\n<div class="l-gap--xss">\n<div class="p-form-term">\n<div class="p-form-term__col">\n <span>西暦</span>\n<div class="c-form-select p-form-term__year">\n <select id="history[0][start_year]" name="history[0][start_year]" class="js-add-block-value js-calc-start_year">\n<option selected="selected" value="">----</option>\n'+addYearList()+'</select>\n</div>\n <label for="history[0][start_year]" class="js-add-block-value">年</label>\n<div class="c-form-select p-form-term__month">\n <select id="history[0][start_month]" name="history[0][start_month]" class="js-add-block-value js-calc-start_month">\n<option selected="selected" value="">--</option>\n<option value="1">1</option>\n<option value="2">2</option>\n<option value="3">3</option>\n<option value="4">4</option>\n<option value="5">5</option>\n<option value="6">6</option>\n<option value="7">7</option>\n<option value="8">8</option>\n<option value="9">9</option>\n<option value="10">10</option>\n<option value="11">11</option>\n<option value="12">12</option>\n</select>\n</div>\n <label for="history[0][start_month]" class="js-add-block-value">月</label>\n</div>\n<div class="p-form-term__col">\n <span class="p-form-term__tilde">〜</span>\n<div class="c-form-select p-form-term__year">\n <select id="history[0][end_year]" name="history[0][end_year]" class="js-add-block-value js-calc-end_year">\n<option selected="selected" value="">----</option>\n'+addYearList()+'</select>\n</div>\n <label for="history[0][end_year]" class="js-add-block-value">年</label>\n<div class="c-form-select p-form-term__month">\n <select id="history[0][end_month]" name="history[0][end_month]" class="js-add-block-value js-calc-end_month">\n<option selected="selected" value="">--</option>\n<option value="1">1</option>\n<option value="2">2</option>\n<option value="3">3</option>\n<option value="4">4</option>\n<option value="5">5</option>\n<option value="6">6</option>\n<option value="7">7</option>\n<option value="8">8</option>\n<option value="9">9</option>\n<option value="10">10</option>\n<option value="11">11</option>\n<option value="12">12</option>\n</select>\n</div>\n <label for="history[0][end_month]" class="js-add-block-value">月</label>\n</div>\n</div>\n</div>\n<div class="l-gap--xs">\n<ul class="c-list-icon">\n<li>\n <span class="c-list-icon__icon c-text-sm">※</span>\n <span class="c-list-icon__text c-text-sm">期間を入力すると勤続年数が自動計算されます。</span>\n</li>\n</ul>\n</div>\n<div class="l-gap--xss l-row align-items-center">\n<div class="l-col-auto">\n <label for="history[0][length_year]" class="js-add-block-value">勤続年数</label>\n</div>\n<div class="l-col-5">\n <input type="text" id="history[0][length_year]" name="history[0][length_year]" class="c-form-text js-add-block-value js-calc-length_year" readonly="">\n</div>\n</div>\n</div>\n</td>\n</tr>\n<tr>\n<th>会社名</th>\n<td>\n <input type="text" id="history[0][company_name]" name="history[0][company_name]" class="c-form-text js-add-block-value">\n</td>\n</tr>\n<tr>\n<th>勤務内容</th>\n<td>\n <span class="c-form-checkbox">\n <label>\n <input type="checkbox" id="history[0][job_description_list]_office" name="history[0][job_description_list][]" value="1" class="js-add-block-value">\n <span class="c-form-checkbox__icon"></span>事務</label>\n </span>\n <span class="c-form-checkbox">\n <label>\n <input type="checkbox" id="history[0][job_description_list]_service" name="history[0][job_description_list][]" value="2" class="js-add-block-value">\n <span class="c-form-checkbox__icon"></span>販売・接客</label>\n </span>\n <span class="c-form-checkbox">\n <label>\n <input type="checkbox" id="history[0][job_description_list]_sales" name="history[0][job_description_list][]" value="3" class="js-add-block-value">\n <span class="c-form-checkbox__icon"></span>営業</label>\n </span>\n <span class="c-form-checkbox">\n <label>\n <input type="checkbox" id="history[0][job_description_list]_others" name="history[0][job_description_list][]" value="4" class="js-add-block-value">\n <span class="c-form-checkbox__icon"></span>その他</label>\n </span>\n</td>\n</tr>\n<tr>\n<th>雇用形態</th>\n<td>\n <span class="c-form-radio">\n <label>\n <input type="radio" id="history[0][employment_status_list]_permanent_employee" name="history[0][employment_status_list]" value="1" class="js-add-block-value">\n <span class="c-form-radio__icon"></span>正社員</label>\n </span>\n <span class="c-form-radio">\n <label>\n <input type="radio" id="history[0][employment_status_list]_contract_employee" name="history[0][employment_status_list]" value="2" class="js-add-block-value">\n <span class="c-form-radio__icon"></span>契約社員</label>\n </span>\n <span class="c-form-radio">\n <label>\n <input type="radio" id="history[0][employment_status_list]_part-time" name="history[0][employment_status_list]" value="3" class="js-add-block-value">\n <span class="c-form-radio__icon"></span>パート</label>\n </span>\n <span class="c-form-radio">\n <label>\n <input type="radio" id="history[0][employment_status_list]_others" name="history[0][employment_status_list]" value="4" class="js-add-block-value">\n <span class="c-form-radio__icon"></span>その他</label>\n </span>\n</td>\n</tr>\n</tbody>\n</table>\n</div>';

//勤務年数計算処理
const calculationTerm = () => {
  const jobHistories = document.querySelectorAll('.js-job-history');
  if (jobHistories) {
    jobHistories.forEach(target => {
      const termSelect = target.querySelectorAll('.p-form-term select');
      if (termSelect) {
        const startYear = target.querySelector('.js-calc-start_year');
        const startMonth = target.querySelector('.js-calc-start_month');
        const endYear = target.querySelector('.js-calc-end_year');
        const endMonth = target.querySelector('.js-calc-end_month');
        const taregetArray = [startYear, startMonth, endYear, endMonth];
        const result = target.querySelector('.js-calc-length_year');
        taregetArray.forEach(el => {
          el.addEventListener('change', () => {
            //生まれた西暦
            const startYearOptions = startYear.options;
            const startYearText = startYearOptions[startYearOptions.selectedIndex].text;
            let startYearNumber = '';
            if (startYearText.indexOf('-') === -1) {
              startYearNumber = Number(startYearText);
            }
            //生まれた月
            const startMonthOptions = startMonth.options;
            const startMonthText = startMonthOptions[startMonthOptions.selectedIndex].text;
            let startMonthNumber = '';
            if (startYearText.indexOf('-') === -1) {
              startMonthNumber = Number(startMonthText);
            }
            //現在の西暦
            const endYearOptions = endYear.options;
            const endYearText = endYearOptions[endYearOptions.selectedIndex].text;
            let endYearNumber = '';
            if (startYearText.indexOf('-') === -1) {
              endYearNumber = Number(endYearText);
            }
            //現在の月
            const endMonthOptions = endMonth.options;
            const endMonthText = endMonthOptions[endMonthOptions.selectedIndex].text;
            let endMonthNumber = '';
            if (startYearText.indexOf('-') === -1) {
              endMonthNumber = Number(endMonthText);
            }

            const calcArray = [startYearNumber, startMonthNumber, endYearNumber, endMonthNumber];
            if (calcArray.includes(NaN) == false && calcArray.includes('') == false ) {
              if ((endMonthNumber - startMonthNumber) < 0) {
                if ((endYearNumber - startYearNumber - 1) >= 0) {
                  result.value = ((endYearNumber - startYearNumber - 1) + '年') + ((12 - ((endMonthNumber - startMonthNumber) * -1)) + 'ヶ月');
                } else {
                  result.value = '';
                }
              } else if ((endYearNumber - startYearNumber) < 0) {
                result.value = '';
              } else {
                result.value = (endYearNumber - startYearNumber + '年') + (endMonthNumber - startMonthNumber + 'ヶ月');
              }
            } else {
              result.value = '';
            }
          });
        })
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  calculationTerm();
  const lastElement = document.querySelector('.js-add-block');
  const addButton = document.querySelector('.js-add-block button');
  //職歴入力ブロックを取得
  const getJobHistories = () => {
    let jobHistories = document.querySelectorAll('.js-job-history');
    jobHistories = Array.prototype.slice.call(jobHistories);
    return jobHistories;
  }
  //タイトル内の数値・インクリメント調整
  const fixValue = () => {
    const jobHistories = getJobHistories();
    if (jobHistories) {
      jobHistories.forEach((target, index) => {
        const title = target.querySelector('.js-add-block-title').textContent;
        const newTitleNumber = index + 1;
        const newTitle = title.replace(/[0-9]/g, newTitleNumber);
        target.querySelector('.js-add-block-title').textContent = newTitle;
        //各属性値のインクリメント処理
        const values = target.querySelectorAll('.js-add-block-value');
        values.forEach(value => {
          //name
          const name = value.getAttribute('name');
          if (name) {
            const newName = name.replace(/[0-9]/g, index);
            value.setAttribute('name', newName);
          }
          //id
          const id = value.getAttribute('id');
          if (id) {
            const newId = id.replace(/[0-9]/g, index);
            value.setAttribute('id', newId);
          }
          //for
          const labelFor = value.getAttribute('for');
          if (labelFor) {
            const newLabelFor = labelFor.replace(/[0-9]/g, index);
            value.setAttribute('for', newLabelFor);
          }
        });
      });
    }
  }
  //削除ボタン押下時の処理
  const removeJobHistory = () => {
    const jobHistories = getJobHistories();
    if (jobHistories) {
      jobHistories.forEach((jobHistory, index) => {
        if (index !== 0) {
          const removeButton = jobHistory.querySelector('.js-remove-block button');
          removeButton.addEventListener('click', () => {
            jobHistory.remove();
            if (jobHistory !== jobHistories.slice(-1)[0]) {
              fixValue();
            }
            if (lastElement.style.display === 'none') {
              lastElement.style.display = 'block';
            }
          });
        }
      });
    }
  };
  if (addButton) {
    fixValue();
    removeJobHistory();
    let jobHistories = getJobHistories();
    if (jobHistories.length >= 7) {
      lastElement.style.display = 'none';
    }
    addButton.addEventListener('click', () => {
      jobHistories = getJobHistories();
      //職歴ブロックの数が7以下だった場合のみ実行
      if (jobHistories.length < 7) {
        //テンプレートを追加
        lastElement.insertAdjacentHTML('beforebegin', template);
        fixValue();
        calculationTerm();
        jobHistories = getJobHistories();
        removeJobHistory();
        //7個表示時は追加ボタンを非表示
        if (jobHistories.length == 7) {
          lastElement.style.display = 'none';
        }
      }
    });
  }
});
